import Vue from 'vue'
import VueI18n from 'vue-i18n'
import th from './locales/th'
import en from './locales/en'
import my from './locales/my'
import ch from './locales/ch'

Vue.use(VueI18n)

const messages: {[key: string]: any} = {
  th,
  en,
  my,
  ch
}

const i18n = new VueI18n({
  locale: 'th', // ภาษาเริ่มต้น
  fallbackLocale: 'th', // ภาษาสำรองถ้าไม่พบคำแปล
  messages
})

export default i18n
